var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08825 4.51709C2.08114 4.63535 2.07758 4.75804 2.07758 4.88515C2.07758 7.38457 1.55433 7.84609 0.813882 8.75269C0.506971 9.12825 0.775518 9.69217 1.31261 9.69217H7.61179",
    fill: "#AFB0B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3382 8.28717C9.80517 7.61076 9.455 6.93002 9.455 4.88346C9.455 2.59605 8.2862 1.7806 7.32393 1.38456C7.19614 1.33206 7.07586 1.21149 7.03692 1.08025C6.86846 0.505942 6.39569 0 5.76629 0C5.1369 0 4.66441 0.50623 4.49711 1.08082C4.45817 1.21351 4.33789 1.33206 4.20866 1.38456C4.03012 1.45738 3.85666 1.54209 3.68945 1.63811",
    fill: "#AFB0B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61212 9.69189V10.1535C7.61212 10.6432 7.4176 11.1128 7.07134 11.459C6.72508 11.8053 6.25546 11.9998 5.76578 11.9998C5.2761 11.9998 4.80647 11.8053 4.46022 11.459C4.11396 11.1128 3.91943 10.6432 3.91943 10.1535V9.69189",
    fill: "#AFB0B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.697697 0.803166C0.99059 0.510273 1.46546 0.510273 1.75836 0.803166L11.0917 10.1365C11.3846 10.4294 11.3846 10.9043 11.0917 11.1972C10.7988 11.4901 10.3239 11.4901 10.031 11.1972L0.697697 1.86383C0.404804 1.57093 0.404804 1.09606 0.697697 0.803166Z",
    fill: "#AFB0B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.d2b6c31c8505371d2f07bee62e026047.svg";
export { ForwardRef as ReactComponent };